import { Accordion, AccordionDetails, Button, Typography } from "@mui/material";
import { Link } from "react-router";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { AccordionSummaryWithSpacing } from "./styled/AccordionSummaryWithSpacing.tsx";
import { SummaryList } from "./SummaryList.tsx";
import { SummaryListItem } from "../types/SummaryListItem.ts";
import { ButtonMode } from "../types/ButtonMode.ts";
import { trackEvent } from "../util/analytics.ts";
import { EventCategory } from "@labs/shared/types/EventCategory.ts";

type SummaryAccordionProps = {
  header: string;
  buttonText: string;
  buttonHref: string;
  buttonMode: ButtonMode;
  textContent: SummaryListItem[];
};

export const SummaryAccordion = ({
  header,
  buttonText,
  buttonHref,
  buttonMode,
  textContent,
}: SummaryAccordionProps) => (
  <Accordion defaultExpanded>
    <AccordionSummaryWithSpacing expandIcon={<ExpandMoreIcon />}>
      <Typography variant={"body1"}>{header}</Typography>
      <Button
        variant={buttonMode === ButtonMode.Start ? "contained" : "outlined"}
        color={buttonMode === ButtonMode.Start ? "secondary" : "inherit"}
        component={Link}
        to={buttonHref}
        onClick={() => {
          trackEvent(EventCategory.Plan, buttonMode, header, buttonHref);
        }}
      >
        {buttonText}
      </Button>
    </AccordionSummaryWithSpacing>
    <AccordionDetails sx={{ paddingTop: 0 }}>
      <SummaryList textContent={textContent} />
    </AccordionDetails>
  </Accordion>
);
